module.exports = __webpack_public_path__ + "static/media/Resume.2e1a9b7b.pdf";